import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import {separateurNumber} from "../../../../libs/helper";

//import Staff from "../Staff";
import {PageLoader} from "../../../components/Loader";
//import Modal from "../../../components/Modal";
import createLink from "../../../../libs/createLink";
//import {getForumsStats} from "../../../../actions/forumsStats";

import {fetchUsersOnline, resetUsersOnline} from "../../../../creators/users.online";
import {fetchForumsStats} from "../../../../creators/forums.stats";
// import {fetchUsers, resetUsers} from "../../../../creators/users";


class ForumStats extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            toggleTopMods: false,
            toggleTopUsers: false,
        };
        this.props.fetchForumsStats();
        // this.props.resetUsersOnline();
        // this.props.fetchUsersOnline();
        // this.props.resetUsers();
        // this.props.fetchUsers({online : true, limit : 100, sort : "-lastActivity", fields : "username,slug,profile,lastActivity,role"});
    }

    render() {
        return (
            <div className="forum-card">
                {this.props.forumsStatsInitialized && !this.props.forumsLoading && !this.props.forumsStatsLoading ? (
                    <div className="card">
                        <div className="global-informations">
                            <div className="global-informations-total"><span
                                className="important-value">{separateurNumber(this.props.forumsStats && this.props.forumsStats.totalMessages)}</span> Total
                                des messages
                            </div>
                            <div className="global-informations-total"><span
                                className="important-value">{separateurNumber(this.props.forumsStats && this.props.forumsStats.totalMembers)}</span> Total
                                des membres
                            </div>
                            {this.props.forumsStats && this.props.forumsStats.owner ? (
                                <div className="global-informations-total"><span
                                    className="important-value"><Link
                                    to={createLink("userProfile", this.props.forumsStats.owner)}>{this.props.forumsStats.owner.username}</Link></span> Dernier
                                    membre</div>) : ''}
                           {/* <div className="global-informations-total"><span
                                className="important-value">{this.props.forumsStats && this.props.forumsStats.recordConnectes}</span> Record de
                                connectés simultanés
                            </div>*/}
                            <div className="global-informations-total last-message">
                                <Link to={`${createLink("forumLastTopics")}`} rel="nofollow noreferrer">
                                    Derniers messages
                                </Link>
                            </div>
                        </div>
                        {/*<div className="forum-card-user-list">
                            <div className="forum-card-topline">
                                <div>
                                    {this.props.forumsStats.memberConnect} membre(s), {this.props.forumsStats.invityConnect} invité(s), {this.props.forumsStats.anonymousConnect} utilisateur(s)
                                    anonyme(s) connecté(s)
                                </div>
                                <div className="forum-card-user-rank">
                                    <span onClick={() => this.setState({toggleTopMods: true})}> L'équipe des modérateurs </span>
                                    <Modal toggle={this.state.toggleTopMods}
                                           handleClose={() => this.setState({toggleTopMods: false})}>
                                        <Staff/>
                                    </Modal>
                                    <Link to="/top-users"><span>Liste des membres</span></Link>
                                </div>
                            </div>
                            <div className="forum-card-stats-users">
                                {this.props.users.map((item, index) =>
                                        <li key={index}><Link to={createLink("userProfile", item) } className={classRoles(item.role)}>{item.username}</Link>{index < (this.props.users.length - 1) ? ', ' : ''}
                                </li>
                                )}
                            </div>
                        </div>*/}
                    </div>
                ) : (
                    <div className="card py-64">
                        <PageLoader/>
                    </div>
                )}
            </div>
        )
    }
}

// export default ForumStats;

const mapStateToProps = (state) => {
    return {
        forumsStats: state.forumsStats.data,
        forumsStatsLoading: state.forumsStats.loading,
        forumsStatsInitialized: state.forumsStats.initialized,
        // users : state.usersOnline.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    //getForumsStats,
    fetchForumsStats,
    // fetchUsers,
    // resetUsers
    fetchUsersOnline,
    resetUsersOnline
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ForumStats);